export const PRODUCT_GROUPS_NAME = 'product-groups';
export const MARKETING_NAME = 'marketing';
export const CORE_NAME = 'core';
export const PRICE_SHEETS_NAME = 'price-sheets';
